/* global AppleID */
import IdentityProvider from './IdentityProvider';
import {IIdentityProviderCredentials} from '../IIdentityProvider';

/**
 * Represents AppleIdentityProvider
 */
class AppleIdentityProvider extends IdentityProvider {
	/**
	 * Authenticate and sign in the user
	 * @returns {Promise} promise resolved when the auth process ends
	 */
	protected auth() {
		AppleID.auth.init({
			clientId: this.config.clientId,
			scope: 'name email',
			redirectURI: `${window.location.origin}/`,
			usePopup: true
		});

		return AppleID.auth.signIn();
	}

	/**
	 * Return the provider credentials
	 * @returns { Promise<IIdentityProviderCredentials>|null} object containing credentials
	 */
	async getProviderCredentials(): Promise<IIdentityProviderCredentials> {
		try {
			const response = await this.auth();

			const providerCredentials = {
				'providerId': 'apple',
				'providerData': {
					'identityToken': response.authorization.id_token,
				}
			};

			const userData = response.user?.name ? {user: response.user.name} : {};

			return {
				...providerCredentials,
				...userData
			};
		} catch (e) {
			return null;
		}
	}
}

export default new AppleIdentityProvider();